/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import UserRoles from './user-roles';
import UserRolesDetail from './user-roles-detail';
import UserRolesUpdate from './user-roles-update';
import UserRolesDeleteDialog from './user-roles-delete-dialog';

const UserRolesRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<UserRoles />} />
    <Route path="new" element={<UserRolesUpdate />} />
    <Route path=":id">
      <Route index element={<UserRolesDetail />} />
      <Route path="edit" element={<UserRolesUpdate />} />
      <Route path="delete" element={<UserRolesDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default UserRolesRoutes;
